import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        console.error('Необработанная ошибка интерфейса:', error);
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        return (
            <div role="alert" style={{ padding: '3rem 1rem', textAlign: 'center' }}>
                <h2>Что-то пошло не так</h2>
                <p>Перезагрузите страницу. Черновики форм сохранены.</p>
                <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
                    Перезагрузить
                </button>
            </div>
        );
    }
}

export default ErrorBoundary;
